<script setup>
import { computed } from 'vue';
import { Dropdown } from 'floating-vue';
import { useI18n } from 'vue-i18n';
import AcquisitionDetails from './AcquisitionDetails.vue';
import { acquisitionNetwork } from './acquisitionNetwork';

const props = defineProps({
  acquisition: { type: Object, default: () => ({}) },
});
const { t } = useI18n();
const fields = computed(() => props.acquisition?.fields || {});
const network = computed(() => acquisitionNetwork(fields.value));
</script>

<template>
  <div
    v-if="Object.keys(fields).length"
    class="mt-2"
    @click.stop
    @pointerdown.stop
  >
    <Dropdown
      theme="tooltip"
      container="body"
      placement="bottom-start"
      :triggers="['hover', 'focus', 'click']"
      :popper-triggers="['hover']"
      :delay="{ show: 150, hide: 200 }"
    >
      <button
        type="button"
        :aria-label="t('ACQUISITION.DETAILS')"
        class="inline-flex max-w-full items-center gap-1.5 rounded-md bg-n-alpha-1 px-2 py-1 text-[11px] text-n-slate-11"
      >
        <span :class="network.icon" class="size-3.5 shrink-0" />
        <span class="truncate">{{
          network.name || t('ACQUISITION.UNKNOWN')
        }}</span>
      </button>
      <template #popper>
        <div
          class="max-h-[70vh] w-80 max-w-[85vw] overflow-y-auto rounded-lg bg-n-solid-1 p-4"
          @click.stop
        >
          <AcquisitionDetails :acquisition="acquisition" expanded />
        </div>
      </template>
    </Dropdown>
  </div>
</template>
